import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Quote } from 'lucide-react';

const testimonials = [
  {
    quote: 'Renáta munkája lenyűgöző! Szuper módszerek, izgalmas előadásmód, profi kommunikáció. Csak ajánlani tudom!',
    author: 'K. Szabin',
  },
  {
    quote: 'Ingatlanos pályafutásom meghatározó szereplői a lelkes és szakképzett oktatási team. Hihetetlenül hálás vagyok nektek!',
    author: 'M. Viktor',
  },
  {
    quote: 'Az oktató tréner részletesen és pontosan tudott tájékoztatni mindenvel kapcsolatban és teljesen korrekt módon oktatott minket a csoporttal. Tóth Gabi egy remek tréner!',
    author: 'Sz. Ármin',
  },
  {
    quote: 'Átgondolt, a változásokhoz alkalmazkodó, jól használható, gyakorlati képzésekkel találkozhattok. Garantáltan elégedettek lehettek mind az oktatott témák gyakorlatiasságával, mind a képzett oktatókkal. Mindenképpen ajánlom!',
    author: 'F. Attila',
  },
];

export const Testimonials = () => {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(1);
  const [touchStart, setTouchStart] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setDirection(1);
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [current]);

  const goTo = (idx) => {
    setDirection(idx > current ? 1 : -1);
    setCurrent(idx);
  };

  const handleTouchStart = (e) => {
    setTouchStart(e.touches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    if (touchStart === null) return;
    const diff = touchStart - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        setDirection(1);
        setCurrent((prev) => (prev + 1) % testimonials.length);
      } else {
        setDirection(-1);
        setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);
      }
    }
    setTouchStart(null);
  };

  return (
    <section
      className="section-padding relative overflow-hidden"
      data-testid="testimonials-section"
    >
      <div className="absolute inset-0 z-0">
        <img loading="lazy" src="https://images.pexels.com/photos/7096/people-woman-coffee-meeting.jpg?auto=compress&cs=tinysrgb&w=1920" alt="Szakmai megbeszélés az Akadémián — készségfejlesztő tréning" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/80" />
      </div>
      <div className="container-custom relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.3 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <p className="text-brand-light-green font-mono text-sm tracking-widest uppercase mb-4">
            Visszajelzések
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-white">
            Amit rólunk mondanak
          </h2>
        </motion.div>

        <div
          className="max-w-3xl mx-auto relative"
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          <AnimatePresence mode="wait" custom={direction}>
            <motion.div
              key={current}
              custom={direction}
              initial={{ opacity: 0, x: direction * 80 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: direction * -80 }}
              transition={{ duration: 0.5 }}
              className="glass-card p-6 md:p-10 relative"
              data-testid={`testimonial-${current}`}
            >
              <Quote size={40} className="text-[#56999B]/30 absolute top-6 right-6" />
              <p className="text-white/80 text-lg md:text-xl leading-relaxed mb-6 relative z-10">
                "{testimonials[current].quote}"
              </p>
              <div className="border-t border-[#56999B]/20 pt-4">
                <p className="font-semibold text-[#C4DB72] text-lg">{testimonials[current].author}</p>
              </div>
            </motion.div>
          </AnimatePresence>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, idx) => (
              <button
                key={idx}
                onClick={() => goTo(idx)}
                className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                  idx === current ? 'bg-brand-light-green w-8' : 'bg-white/30 hover:bg-white/50'
                }`}
                aria-label={`Visszajelzés ${idx + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
